<div class="container d-flex align-items-center justify-content-center min-vh-100 py-5">
    <div class="card shadow border-0 rounded-4 p-2" style="max-width: 600px; width: 100%;">
        <div class="card-body p-4">
            <div class="text-center mb-4">
                <img src="logo-login.svg" alt="Logo" class="img-fluid mb-3" style="height: 50px;">
                <h3 class="h5 fw-bold heading">Upload the Document as per the request</h3>
                <hr class="opacity-10">
            </div>
            <form [formGroup]="documentUploadForm" (ngSubmit)="onSubmit()">
                @if (showError) {
                    <div class="alert alert-warning">
                        {{ errorMessage }}
                    </div>
                } @else {
                    @for (doc of documentItems; track doc.document.value) {
                        <div class="mb-4">
                            <label class="form-label small fw-semibold text-secondary">
                                Please Upload: <span class="text-dark">{{ doc.document.value | humanizeConstant }}</span>
                            </label>
                            <div class="input-group">
                                <input type="file"
                                       class="form-control"
                                       [class.is-valid]="doc.uploadedUrl"
                                       (change)="onFileSelect($event, doc)">

                                @if (doc.uploadedUrl) {
                                    <span class="input-group-text bg-success-subtle text-success border-success">
                                  <i class="bi bi-check-circle-fill"></i>
                                </span>
                                }
                            </div>

                            @if (doc.progress !== undefined) {
                                <div class="progress mt-2" style="height: 8px;">
                                    <div class="progress-bar progress-bar-striped progress-bar-animated"
                                         role="progressbar"
                                         [style.width.%]="doc.progress >= 0 ? doc.progress : 100"
                                         [ngClass]="{
                                        'bg-success': doc.progress === 100,
                                        'bg-danger': doc.progress === -1,
                                        'bg-primary': doc.progress >= 0 && doc.progress < 100
                                     }">
                                    </div>
                                </div>
                                <div class="d-flex justify-content-between mt-1">
                                    <small class="text-muted">
                                        {{ doc.progress === -1 ? 'Upload Failed' : (doc.progress + '%') }}
                                    </small>
                                    @if (doc.uploadedUrl) {
                                        <small class="text-success fw-bold">Please continue</small>
                                    }
                                </div>
                            }
                        </div>
                    } @empty {
                        <span class="spinner-border spinner-border-sm me-2"></span>
                        Please wait...
                    }
                }


                <div class="d-grid mt-5">
                    <button class="btn btn-primary btn-lg rounded-pill shadow-sm py-3"
                            type="submit"
                            [disabled]="!canSubmit()"
                            (click)="onSubmit()">
                        @if (loading) {
                            <span class="spinner-border spinner-border-sm me-2"></span>
                            Please wait...
                        } @else {
                            Upload the Document list
                        }
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
